<template>
  <div>
    <div class="crumbs" v-if="page">
      <div>{{ page.name }} > {{ page[subType] && page[subType].name }}</div>
    </div>
    <div class="container-width">
      <div class="detail">
        <div class="content" v-html="content"></div>
      </div>
    </div>
  </div>
</template>
<script>
import { singlePages } from '@/page/constants'
import { getNewsPage, getNewsDetail } from '@/service/apis/news'
export default {
  name: 'SinglePage',
  data () {
    return {
      page: null,
      content: '',
      id: '',
      type: '',
      subType: ''
    }
  },
  watch: {
    '$route.query.type'(val) {
      if (val && val.split('-').length) {
        let arr = val.split('-')
        this.type = arr[0]
        this.subType = arr[1]

        this.getPage()
        this.getList()
      }
    },
  },
  created() {
    let ids = this.$route.query.type
    if (!ids) {
      this.$router.back()
    } else {
      let arr = ids.split('-')
      this.type = arr[0]
      this.subType = arr[1]

      this.getPage()
      this.getList()
    }
  },
  methods: {
    getPage () {
      let page = singlePages.find(item => item.id === parseInt(this.type))
      if (page && page.children && page.children.length) {
        page.children.forEach(item => {
          page[item.id] = item
        })
      }
      this.page = {...page}
    },
    getList () {
      let opt = {
        pageIndex: 1,
        pageSize: 1,
        type: this.type,
        subType: this.subType
      }
      getNewsPage.call(this, opt).then(res => {
        let data = res.data
        let records = data.records
        if (records && records.length) {
          this.getDetail(records[0].id)
        }
      })
    },
    // 详细
    getDetail (id) {
      getNewsDetail.call(this, { id }).then(res => {
        if (res.errCode === 0) {
          const data = res.data
          if (data.newsDetailDto) {
            this.content = data.newsDetailDto.content || ''
          }
        }
      })
    }
  },
}
</script>
<style scoped>
.detail {
  padding-top: 12px;
  height: auto;
  overflow: hidden;
}

.detail .content {
  padding: 12px 0;
  padding-bottom: 48px;
  color: #666;
  min-height: 250px;
  line-height: 28px;
}
.detail .content img {
  max-width: 100%;
  height: auto;
}

</style>
